import { combineReducers } from 'redux'

import bezirke from './bezirke'
import kreise from './kreise'
import fachgebiete from './fachgebiete'
import events from './events'
import filters from './filters'

export default combineReducers({
    bezirke, kreise, fachgebiete, events, filters
})


// WEBPACK FOOTER //
// ./src/reducers/index.js